import React from 'react';
import styled from 'styled-components';
import { SelectInputSkeleton } from '@hotelplan/components.common.select-input';
import { useDeviceType } from '@hotelplan/libs.context.device-type';
import { sx2CssThemeFn } from '@hotelplan/util.theme.sxc';
import {
  COMPARE_ITEMS_COUNT_DESKTOP,
  COMPARE_ITEMS_COUNT_MOBILE,
} from 'fdr/components/local/fdr-wishlist/fdr-wishlist.constants';

export const WishlistItemSelectSkeletonWrapper = styled.div(
  sx2CssThemeFn({
    display: 'flex',
    my: 3,
    flexWrap: 'wrap',
  })
);

export const WishlistItemsWrapper = styled.div(
  sx2CssThemeFn({
    display: 'flex',
    flex: 1,
    mx: [-2, -3],
  })
);

const SelectInputSkeletonWrapper = styled.div(
  sx2CssThemeFn({
    width: ['50%', `${100 / 3}%`],
    mx: [2, 3],
    '.wishlist-item-select-skeleton': {
      py: ['21px', '23px'],
    },
  })
);

export const WishlistItemSelectSkeleton: React.FC = () => {
  const { mobile } = useDeviceType();

  return (
    <WishlistItemSelectSkeletonWrapper>
      <WishlistItemsWrapper>
        {Array.from({
          length: mobile
            ? COMPARE_ITEMS_COUNT_MOBILE
            : COMPARE_ITEMS_COUNT_DESKTOP,
        }).map((_, i) => (
          <SelectInputSkeletonWrapper key={`skeleton-${i}`}>
            <SelectInputSkeleton className="wishlist-item-select-skeleton" />
          </SelectInputSkeletonWrapper>
        ))}
      </WishlistItemsWrapper>
    </WishlistItemSelectSkeletonWrapper>
  );
};
